import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["previewImage"];

  updateMobileItems(radio) {
    const mobileDropdown = this.element.querySelector("[data-mobile-dropdown]");
    if (!mobileDropdown) return;

    mobileDropdown.querySelectorAll("label[for]").forEach((label) => {
      const isSelected = label.getAttribute("for") === radio.id;
      label.querySelector("[data-selected-icon]")?.classList.toggle("hidden", !isSelected);
      label.querySelector("[data-unselected-icon]")?.classList.toggle("hidden", isSelected);
    });

    const selectedName = mobileDropdown
      .querySelector(`label[for="${radio.id}"] [data-item-name]`)
      ?.textContent?.trim();
    const trigger = mobileDropdown.querySelector("button");

    if (selectedName && trigger) {
      const icon = trigger.lastElementChild;
      trigger.textContent = selectedName;
      trigger.appendChild(icon);
    }
  }

  updatePreviewImage(imageValue, nameValue) {
    if (!this.hasPreviewImageTarget || !imageValue) {
      return;
    }

    this.previewImageTarget.src = this.getImagePath(imageValue);
    this.previewImageTarget.alt = nameValue || "Preview";
  }

  getFieldNameFromInput(input) {
    const match = input.name.match(/\[(.*?)\]$/);
    return match ? match[1] : input.name;
  }

  getImagePath(imageValue) {
    if (!imageValue) return "";
    if (imageValue.startsWith("//")) {
      return `https:${imageValue}`;
    }
    if (imageValue.startsWith("http")) {
      return imageValue;
    }
    return imageValue;
  }
}
